<template>
    <div class="breadcrumbs-inner" v-if="breadcrumbs" ref="root">
        <div>
            <template v-for="(item, index) in breadcrumbList.links" v-bind:key="'b_' + index">
                <a :id="item.id ? item.id+'-link' : null" :href="item.path" :title="item.title">{{ item.title }}</a>
                <i>/</i>
            </template>
            <span>{{ props.customTitle || breadcrumbList.current.title }}</span>
        </div>
    </div>
</template>
<script setup>
import { ref, watch, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { i18n } from 'I18n'
import breadCrumbMetrics from "modules/metrics/breadCrumbsMetrics.js"

    const breadcrumbs = ref(null)
    const root = ref(null)
    const route = useRoute()

    const updateBreadcrumbs = (route) => {
      breadcrumbs.value = route.meta.breadcrumbs ? route.meta.breadcrumbs(route) : null
    }

    const updateBreadcrumbsVisibility = (route) => {
      if (root.value)
         root.value.parentElement.style.display = route.meta.breadcrumbs ? 'block' : 'none'
    }

    updateBreadcrumbs(route)

    watch(() => route.value, () => {
        updateBreadcrumbs(route)
        updateBreadcrumbsVisibility(route)
    })

    onMounted(() => {
        updateBreadcrumbsVisibility(route)
        breadCrumbMetrics({ page: route.name })
    })

    const props = defineProps({
        customTitle: String
    })

    const breadcrumbList = computed(() => {
        const links = breadcrumbs.value
        const current = links.pop()
        
        links.unshift({ title: i18n.t('common.breadcrumbs.main'), path: '/', id: 'main' })
        return { links, current }
    })
</script>
<style lang="scss">
    @import '~styles/colors';

    .breadcrumbs {
        text-align: left;
        line-height: 32px;
        padding-left: 20px;
        position: relative;
        border-top: 1px solid $breadcrumbs-border-color;
        border-bottom: 1px solid $breadcrumbs-border-color;
        height: 35px;
        min-height: 35px;
        width: 100%;
        flex: none;
        color: $main-font-color;
        font-family: 'Open Sans',sans-serif;
        display: none;

        .breadcrumbs-inner {
            min-width: 1246px;
            max-width: 1366px;
            text-align: center;
            margin: 0 auto;

            > div {
                text-align: left;

                span, a {
                    font-size: 10px;
                    text-transform: uppercase;
                    color: $breadcrumbs-text-color;
                    font-weight: 700;
                    text-decoration: none;
                    letter-spacing: .075em;
                }

                i {
                    font-size: 10px;
                    color: $breadcrumbs-text-color;
                    font-weight: 700;
                    padding: 0 5px 0 5px;
                }

                a:hover {
                    text-decoration: underline;
                    color: $main-blue-color;
                }
            }
        }
    }
</style>
